// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fc8d6ed2","455":"176a9d43","977":"eb5cb604"}[chunkId] + ".chunk.js";
};